<template>
    <v-container max-width="100%" style="margin-top: 2%;" fluid>
      <ErroSistema :type="erro.tipo" :message="erro.mensagem" :status="erro.status" ref="erroSistema" />
      
      <v-dialog v-model="infoDialog" fullscreen max-width="100%" max-heigth="100%" style="z-index: 10; background-color: white;">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeInfoDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Informações da Viagem</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-expansion-panels style="margin-bottom: 10px;">
                <v-expansion-panel>
                  <v-expansion-panel-header focusable>
                    <h3 style="color: black;">Dados</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="4" md="2">
                          <strong style="color: black;">Empresa: </strong><span>{{ editedItem.razao_social }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                          <strong style="color: black;">Autorização: </strong><span>{{ editedItem.autorizacao }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                          <strong style="color: black;">Sentido: </strong><span>{{ getSentido(editedItem) }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                          <strong style="color: black;">Data de Início: </strong><span>{{ editedItem.inicio }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                          <strong style="color: black;">Hora Programada: </strong><span>{{ editedItem.hora_programada }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                          <strong style="color: black;">Status: </strong><span>{{ editedItem.status_extenso }}</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <h3 style="color: black;">Veículo</h3>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <strong style="color: black;">Ordem: </strong><span>{{ getOrdem(editedItem) }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <strong style="color: black;">Placa: </strong><span>{{ getPlaca(editedItem) }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <strong style="color: black;">Equipamento: </strong><span>{{ getImei(editedItem) }}</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <h3 style="color: black;">Endereços</h3>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <strong style="color: black;">Partida: </strong><span>{{ editedItem.endereco_partida }}</span>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <strong style="color: black;">Chegada: </strong><span>{{ editedItem.endereco_chegada }}</span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header focusable>
                    <h3 style="color: black;">Logs</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-data-table
                        dense
                        :headers="headersLogsViagem"
                        :items="logsViagem"
                        sort-by="dt_operacao"
                        :sort-desc="true"
                      >
                      </v-data-table>
                      <vue-json-to-csv :json-data="logsViagem" :csv-title="`logsviagem${viagemDownload}`" separator=";">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                              <v-icon>mdi-export-variant</v-icon>
                            </v-btn>
                          </template>
                          <span>Exporta para CSV</span>
                        </v-tooltip>
                    </vue-json-to-csv>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header focusable>
                    <h3 style="color: black;">Erros</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-data-table
                        dense
                        :headers="headersErrosViagem"
                        :items="errosViagem"
                        sort-by="dt_operacao"
                        :sort-desc="true"
                      ></v-data-table>
                      <vue-json-to-csv :json-data="errosViagem" :csv-title="`errosviagem${viagemDownload}`" separator=";">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                              <v-icon>mdi-export-variant</v-icon>
                            </v-btn>
                          </template>
                          <span>Exporta para CSV</span>
                        </v-tooltip>
                    </vue-json-to-csv>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header focusable>
                    <h3 style="color: black;">Movimentos</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-data-table
                        dense
                        :headers="headersMovimentosViagem"
                        :items="movimentosViagem"
                        sort-by="dt_evento"
                        :sort-desc="true"
                      ></v-data-table>
                      <vue-json-to-csv :json-data="movimentosViagem" :csv-title="`movimentosviagem${viagemDownload}`" separator=";">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                              <v-icon>mdi-export-variant</v-icon>
                            </v-btn>
                          </template>
                          <span>Exporta para CSV</span>
                        </v-tooltip>
                    </vue-json-to-csv>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-btn color="primary" dark @click="populaMapa" style="margin-bottom: 15px">{{ plotagemBtn }}</v-btn>

              <v-container v-if="showMapa">
                <MapaPlotagem 
                  ref="mapaPlotagem"
                  :idVeiculo="idVeiculosViagem"
                  :dti="dtiMapa"
                  :dtf="dtfMapa"
                  :token="token"
                  :key="key"
                  style="z-index: 10;"
                ></MapaPlotagem>
              </v-container>

            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-alert
        :type="this.tipoAlerta"
        timeout="5000"
        dismissible
        v-model="showAlert"
        style="margin-bottom: 35px; border-radius: 10px;"
      >
        {{ this.mensagemAlerta }}
      </v-alert>

      <template>
        <v-row justify="center">
          <v-dialog v-model="helpDialog" persistent max-width="60%" style="border-radius: 10px;">
            <v-card>
              <v-card-title style="color: #4a4a4a">
                <h2>Monitriip - Iniciar o envio de informações</h2>
              </v-card-title>
              <v-card-text style="color: #4a4a4a">
                  <h3>Para registrar uma viagem e fazer o acompanhamento dela para o Monitriip, clique na viagem e insira as informações necessárias.</h3>
                  <h3>Para registrar uma viagem que não se encontra na tabela, clique no + e insira todas as informações necessárias.</h3>
                  <p>A tabela é filtrada por data.</p>
                  <h3>Viagens registradas que estão na base de dados da ANTT aparecerão em verde e as que não estão aparecerão em laranja.</h3>
                  <p>A tabela é atualizada todo dia às 6h:30min da manhã.</p>
                  <h3>Caso a viagem não se inicie/finalize automaticamente pela cerca eletrônica, pode-se iniciar/finalizar a viagem manualmente clicando no ícone do ônibus.</h3>
                  <p>Caso ocorra um transbordo, o mesmo deve ser informado clicando-se no mesmo ícone</p>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#4a4a4a"
                  class="white--text"
                  @click="closeHelpDialog()"
                  >Fechar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
  
      <template>
        <v-row justify="center">
          <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px;">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">Mensagem do Sistema</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemdialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red accent-4"
                  class="white--text"
                  @click="confirmDialog = false"
                  >{{ this.messageDismissButton }}</v-btn
                >
                <v-btn
                  v-if="showConfirmButton"
                  color="red accent-4"
                  class="white--text"
                  @click="deleteFromDatabase"
                  >{{ this.messageConfirmButton }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-menu
                  ref="dateMenuFilterLower"
                  v-model="dateMenuFilterLower"
                  :close-on-content-click="false"
                  :return-value.sync="dateToFilterLower"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateToFilterLowerFormatted"
                      label="Data de Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateToFilterLower"
                    no-title
                    scrollable
                    color="#4a4a4a"
                    @input="filterDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-menu
                  ref="dateMenuFilterHigher"
                  v-model="dateMenuFilterHigher"
                  :close-on-content-click="false"
                  :return-value.sync="dateToFilterHigher"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateToFilterHigherFormatted"
                      label="Data de Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateToFilterHigher"
                    no-title
                    scrollable
                    color="#4a4a4a"
                    @input="filterDate"
                  >
                  </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" sm="1" md="1" align="end">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      fab
                      color="primary darken-1"
                      class="white--text mt-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="initialize"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Nova Consulta</span>
                </v-tooltip>
            </v-col>
            </v-row>
          </v-form>
        </v-container>
  
      <v-data-table
        :headers="headers"
        :items="viagensFiltered"
        :search="search"
        :item-class="getViagemStyle"
        :loading="loading"
        dense
        class="elevation-7"
        locale="pt"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
        @click:row="(item) => showInfo(item)"
      >

      <template v-slot:item.placa="{ item }">
        {{  getPlaca(item) }}
      </template>

      <template v-slot:item.ordem="{ item }">
        {{  getOrdem(item) }}
      </template>

      <template v-slot:item.imei="{ item }">
        {{  getImei(item) }}
      </template>

      <template v-slot:item.status="{ item }">
        {{  getStatusExtenso(item) }}
      </template>

      <template v-slot:item.sentido="{ item }">
        {{  getSentido(item) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-layout v-if="item.status != null">
          <v-icon small class="mr-2" :style="{ color: item.status == 1 ? 'red' : 'green' }" @click.stop="getNovoStatusViagem(item)" :disabled="!item.insere_movimento"
            >mdi-bus</v-icon
          > 
          <v-icon small class="mr-2" color="orange" @click.stop="editItem(item)" :disabled="!item.insere_movimento"
            >mdi-pencil</v-icon
          >             
          <v-icon small class="mr-2" color="red" @click.stop="deleteItem(item)" :disabled="!item.can_delete"
            >mdi-delete</v-icon
          >
        </v-layout>
      </template>

        <template v-slot:top>
          <v-toolbar flat color="white" style="border-radius: 10px">
            <v-toolbar-title style="color: #4a4a4a"
              >Viagens</v-toolbar-title
            >
            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Procurar..."
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
  
            <v-btn
              color="#4a4a4a"
              dark
              small
              class="mb-2 mr-2"
              fab
              @click="showHelpDialog"
            >
              <v-icon>mdi-help</v-icon>
            </v-btn>

            <v-dialog v-model="registroDialog" max-width="50%">
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">Iniciar/Parar Viagem</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado" v-if="editedItem.status !== -1">
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-select
                            v-model="novoStatus"
                            :items="status"
                            item-value="valor"
                            item-text="texto"
                            single-line
                            auto
                            label="Novo status da viagem"
                            :rules="[(v) => v !== null || 'Status é obrigatório']"
                          >
                            </v-select>
                          </v-col>
                      </v-row>
                    </v-form>
                  <v-container v-else>
                    <span style="color: black">{{ mensagemIniciar }}</span>
                  </v-container>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#4a4a4a" class="white--text" @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="#4a4a4a" class="white--text" @click="getRastreamentoVeiculo"
                    >Registrar Movimento</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="novaViagemDialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#4a4a4a"
                  dark
                  small
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">Nova Viagem</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="3" md="4">
                          <v-text-field
                                v-model="editedItem.autorizacao"
                                label="Número de licença de viagem *"
                                :rules="[(v) => !!v || 'A autorização da viagem é obrigatória']"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.cnpj"
                          :items="empresas"
                          item-text="razao_social"
                          item-value="cnpj"
                          single-line
                          auto
                          label="Selecione uma Empresa *"
                          :rules="[(v) => !!v || 'Empresa é obrigatória']"
                        ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="4">
                          <v-autocomplete
                                v-model="editedItem.placa"
                                :items="veiculosFiltered"
                                :filter="filterVeiculo"
                                item-value="placa"
                                item-title="placa"
                                single-line
                                auto
                                label="Placa do veículo *"
                                :rules="[placaRules(editedItem.placa)]"
                            >
                            <template v-slot:item="veiculosFiltered">
                                {{ veiculosFiltered.item.placa }}
                            </template>
                            <template v-slot:selection="motoristas">
                              {{ motoristas.item.placa }}
                            </template>  
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                            <v-autocomplete
                              v-model="editedItem.motorista"
                              :items="motoristas"
                              :filter="filterMotorista"
                              item-value="id_funcionario"
                              item-title="nome"
                              single-line
                              auto
                              label="Selecione um Motorista *"
                              :rules="[(v) => !!v || 'Motorista é obrigatório']"
                          >
                              <template v-slot:item="motoristas">
                                {{ motoristas.item.matricula }} {{ motoristas.item.nome }} 
                              </template>
                              <template v-slot:selection="motoristas">
                                {{ motoristas.item.matricula }} {{ motoristas.item.nome }} 
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <v-menu
                              ref="dateMenuInicioManual"
                              v-model="dateMenuInicioManual"
                              :close-on-content-click="false"
                              :return-value.sync="dataProgramada"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              :rules="[(v) => !!v || 'Data de início é obrigatória']"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="dataProgramadaFormatted"
                                  label="Data de início"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="dataProgramada"
                                no-title
                                scrollable
                                color="#4a4a4a"
                                :min="today"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="#4a4a4a"
                                  @click="dateMenuInicioManual = false"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  text
                                  color="#4a4a4a"
                                  @click="$refs.dateMenuInicioManual.save(dataProgramada)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <v-text-field
                                  v-model="horaProgramada"
                                  label="Horário de início"
                                  prepend-icon="mdi-clock"
                                  v-mask="'##:##'"
                                  :rules="[horarioRules]"
                                ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" md="4">
                            <v-select
                              v-model="editedItem.sentido"
                              :items="sentidos"
                              item-value="valor"
                              item-text="texto"
                              single-line
                              auto
                              label="Selecione um sentido *"
                              :rules="[(v) => !!v || 'Sentido é obrigatório']"
                          ></v-select>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-combobox
                              v-model="editedItem.endereco_partida"
                              label="Endereço de partida *"
                              :items="cercas"
                              item-value="endereco"
                              item-text="endereco"
                              :return-object="false"
                              :rules="[(v) => !!v || 'Endereço de partida é obrigatório']"
                          ></v-combobox>
                          </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-combobox
                              v-model="editedItem.endereco_chegada"
                              label="Endereço de chegada *"
                              :items="cercas"
                              item-value="endereco"
                              item-text="endereco"
                              :return-object="false"
                              :rules="[(v) => !!v || 'Endereço de chegada é obrigatório']"
                          ></v-combobox>
                          </v-col>
                        </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#4a4a4a" class="white--text" @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="#4a4a4a" class="white--text" @click="registra"
                    >Registrar Viagem</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog" max-width="100%">
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-container v-if="editedIndex != -1">
                        <v-row>
                          <v-col cols="12" sm="3" md="6">
                            <v-autocomplete
                              v-model="editedItem.motorista"
                              :items="motoristas"
                              :filter="filterMotorista"
                              item-value="id_funcionario"
                              item-title="nome"
                              single-line
                              auto
                              label="Selecione um Motorista *"
                              :rules="[(v) => !!v || 'Motorista é obrigatório']"
                          >
                              <template v-slot:item="motoristas">
                                {{ motoristas.item.matricula }} {{ motoristas.item.nome }} 
                              </template>
                              <template v-slot:selection="motoristas">
                                {{ motoristas.item.matricula }} {{ motoristas.item.nome }} 
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="4" md="6">
                            <v-autocomplete
                                v-model="editedItem.novaPlaca"
                                :items="veiculosFiltered"
                                :filter="filterVeiculo"
                                item-value="placa"
                                item-title="placa"
                                single-line
                                auto
                                label="Placa do veículo *"
                                :rules="[placaRules(editedItem.novaPlaca)]"
                            >
                            <template v-slot:item="veiculosFiltered">
                                {{ veiculosFiltered.item.placa }}
                            </template>
                            <template v-slot:selection="motoristas">
                              {{ motoristas.item.placa }}
                            </template>  
                          </v-autocomplete>
                          </v-col>
                      </v-row>
                      </v-container>
                      <v-container v-else>
                        <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-autocomplete
                                v-model="editedItem.placa"
                                :items="veiculosFiltered"
                                :filter="filterVeiculo"
                                item-value="placa"
                                item-title="placa"
                                single-line
                                auto
                                label="Placa do veículo *"
                                :rules="[placaRules]"
                            >
                            <template v-slot:item="veiculosFiltered">
                                {{ veiculosFiltered.item.placa }}
                            </template>
                            <template v-slot:selection="motoristas">
                              {{ motoristas.item.placa }}
                            </template>  
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                              v-model="editedItem.motorista"
                              :items="motoristas"
                              :filter="filterMotorista"
                              item-value="id_funcionario"
                              item-title="nome"
                              single-line
                              auto
                              label="Selecione um Motorista *"
                              :rules="[(v) => !!v || 'Motorista é obrigatório']"
                          >
                              <template v-slot:item="motoristas">
                                {{ motoristas.item.matricula }} {{ motoristas.item.nome }} 
                              </template>
                              <template v-slot:selection="motoristas">
                                {{ motoristas.item.matricula }} {{ motoristas.item.nome }} 
                              </template>
                            </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-menu
                              ref="dateMenuInicioANTT"
                              v-model="dateMenuInicioANTT"
                              :close-on-content-click="false"
                              :return-value.sync="dataProgramada"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              :rules="[(v) => !!v || 'Data de início é obrigatória']"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="dataProgramadaFormatted"
                                  label="Data de início"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="dataProgramada"
                                no-title
                                scrollable
                                color="#4a4a4a"
                                :min="today"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="#4a4a4a"
                                  @click="dateMenuInicioANTT = false"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  text
                                  color="#4a4a4a"
                                  @click="$refs.dateMenuInicioANTT.save(dataProgramada)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                            v-model="horaProgramada"
                            label="Horário de início"
                            prepend-icon="mdi-clock"
                            v-mask="'##:##'"
                            :rules="[horarioRules]"
                          ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-combobox
                              v-model="editedItem.endereco_partida"
                              label="Endereço de partida *"
                              :items="cercas"
                              item-value="endereco"
                              item-text="endereco"
                              :return-object="false"
                              :rules="[(v) => !!v || 'Endereço de partida é obrigatório']"
                          ></v-combobox>
                          </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-combobox
                              v-model="editedItem.endereco_chegada"
                              label="Endereço de chegada *"
                              :items="cercas"
                              item-value="endereco"
                              item-text="endereco"
                              :return-object="false"
                              :rules="[(v) => !!v || 'Endereço de chegada é obrigatório']"
                          ></v-combobox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-container>
                </v-card-text>
  
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#4a4a4a" class="white--text" @click="close"
                    >Cancelar</v-btn
                  >
                  <v-btn color="#4a4a4a" class="white--text" @click="registra"
                    >Registrar Viagem</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

      </v-data-table>
    </v-container>
  </template>

  <style lang="css">
    .viagemStyleOk {
      color: forestgreen;
      font-weight: bold;
    }

    .viagemStyleInconsistent {
      color: orangered;
    }

    .viagemStyleWrong {
      color: red;
      font-weight: bold;
    }
  </style>
  
  <script>
  import apiController from "@/utils/apiController";
  import MapaPlotagem from "./MapaPlotagem.vue";
  import DateUtils from "../utils/dateutils";
  import VueJsonToCsv from "vue-json-to-csv";
  import ErroSistema from "./Notifications/ErroSistema.vue";

  export default {
    components: {
      ErroSistema,
      MapaPlotagem,
      VueJsonToCsv
    },
    data: () => ({
      erro: {
        tipo: null,
        mensagem: null,
        status: null
      },
      search: "",
      showConfirmButton: true,
      messageConfirmButton: "Sim",
      messageDismissButton: "Não",
      formValidado: true,
      showAlert: false,
      mensagemAlerta: "",
      tipoAlerta: "success",
      dialog: false,
      helpDialog: false,
      novaViagemDialog: false,
      registroDialog: false,
      operacao: 0,
      isAtivo: true,
      confirmDialog: false,
      mensagemdialog: "",
      mensagemIniciar: "",
      disableModelo: true,
      idempresaupload: null,
      mensagemUpload: "",
      arquivoLog: null,
      isMatriculaDisabled: false,
      isAutorizacaoDisabled: false,
      dateMenuInicioManual: false,
      timeMenuInicioManual: false,
      dateMenuInicioANTT: false,
      timeMenuInicioANTT: false,
      dateMenuFilterLower: false,
      dateMenuFilterHigher: false,
      dateToFilterLower: null,
      dateToFilterHigher: null,
      dataProgramada: new Date().toISOString().slice(0, 10),
      horaProgramada: null,
      headers: [
        { text: "IdViagem", value: "id_viagem", align: " d-none" },
        { text: "Empresa", value: "razao_social" },
        { text: "Autorização", value: "autorizacao" },
        { text: "Sentido", value: "sentido" },
        { text: "N° Ordem", value: "ordem" },
        { text: "Placa", value: "placa" },
        { text: "Data de Início", value: "inicio" },
        { text: "Equipamento", value: "imei" },
        { text: "Status", value: "status" },
        { text: "Hora Programada", value: "hora_programada" },
        { text: "Motorista", value: "nome_motorista" },
        // { text: "IdEmpresa", value: "id_empresa", align: " d-none" },
        // { text: "CNPJ", value: "cnpj_empresa", align: " d-none" },
        { text: "Ações", value: "actions", sortable: false }],
      headersErrosViagem: [
        { text: "Data/Hora", value: "dt_operacao_extenso" },
        { text: "Autorização", value: "numero_licenca" },
        { text: "Método", value: "metodo_extenso" },
        { text: "Mensagem", value: "mensagem" },
        { text: "Código Erro", value: "codigo_erro" },
        { text: "Descrição", value: "descricao" }],
      headersLogsViagem: [
        { text: "Data/Hora", value: "dt_operacao_extenso" },
        { text: "Autorização", value: "numero_licenca" },
        { text: "Método", value: "metodo_extenso" },
        { text: "Código", value: "codigo_resposta" },
        { text: "Id Transação", value: "id_transacao" },
        { text: "Mensagem", value: "mensagem" }],
      headersMovimentosViagem: [
        { text: "Data/Hora", value: "dt_evento_extenso" },
        { text: "Autorização", value: "numero_licenca_viagem" },
        { text: "Status", value: "status" },
        { text: "Ordem", value: "numero_ordem" },
        { text: "Placa", value: "placa" },
        { text: "Lat", value: "lat" },
        { text: "Lng", value: "lng" }],
      viagens: [],
      viagensFiltered: [],
      viagensManuais: [],
      empresas: [],
      motoristas: [],
      veiculos: [],
      veiculosFiltered: [],
      equipamentos: [],
      status: [
        {valor: 0, texto: "Finalizada"},
        {valor: 1, texto: "Iniciada"},
        {valor: 2, texto: "Finalizada com Transbordo"},
        {valor: 3, texto: "Iniciada com Transbordo"}
      ],
      novoStatus: null,
      sentidos: [{valor: 1, texto: "Ida"}, {valor:2, texto: "Volta"}],
      editedIndex: -1,
      canConfirm: false,
      infoDialog: false,
      veiculoItem: null,
      editedItem: {
        id_registro: null,
        usuario_registro: null,
        id_viagem: null,
        inicio: null,
        cnpj: null,
        razao_social: null,
        autorizacao: null,
        placa: null,
        placa_registrada: null,
        ordem: null,
        ordem_registrada: null,
        imei: null,
        imei_registrado: null,
        motorista: null,
        cpf_motorista: null,
        cerca_chegada: null,
        cerca_partida: null,
        endereco_partida: null,
        endereco_chegada: null,
        status: null,
        status_extenso: null,
        sentido: null,
        sentido_registrado: null,
        hora_programada: null,
        novoMotorista: null,
        novaPlaca: null
      },
      defaultItem: {
        id_registro: null,
        usuario_registro: null,
        id_viagem: null,
        inicio: null,
        fim: null,
        cnpj: null,
        razao_social: null,
        autorizacao: null,
        placa: null,
        placa_registrada: null,
        ordem: null,
        ordem_registrada: null,
        imei: null,
        imei_registrado: null,
        motorista: null,
        cpf_motorista: null,
        cerca_chegada: null,
        cerca_partida: null,
        endereco_partida: null,
        endereco_chegada: null,
        status: null,
        status_extenso: null,
        sentido: null,
        sentido_registrado: null,
        hora_programada: null,
        novoMotorista: null,
        novaPlaca: null
      },
      authDialog: false,
      sysError: null,
      user: null,
      token: null,
      errosViagem: [],
      loadingErrosViagem: false,
      movimentosViagem: [],
      loadingMovimentosViagem: false,
      dtiMapa: null,
      dtfMapa: null,
      key: 0,
      idVeiculosViagem: [],
      showMapa: false,
      cercas: [],
      logsViagem: [],
      viagemDownload: null,
      loadingLogsViagem: false,
      loading: false,
    }),
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Registrar Viagem" : "Editar Viagem";
      },
      today() {
        return new Date().toISOString().slice(0, 10);
      },
      dateToFilterLowerFormatted() {
        return this.formatDate(this.dateToFilterLower);
      },
      dateToFilterHigherFormatted() {
        return this.formatDate(this.dateToFilterHigher);
      },
      dataProgramadaFormatted() {
        return this.formatDate(this.dataProgramada);
      },
      plotagemBtn() {
        return this.showMapa ? "Esconder Mapa" : "Mostrar Mapa";
      }
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initializeDateFilterLower(-1);
      this.initializeDateFilterHigher(1);
      this.populaEmpresas();
      this.populaFuncionarios();
      this.populaVeiculos();
      this.initialize();
    },
    mounted() {
      this.$root.$emit('eventshowback', true);
    },
    methods: {
      initialize() {
        this.loading = true;
        apiController.request(apiController.endpoints.monitriipGetallViagensdata, {
          data: {
            dti: this.dateToFilterLower,
            dtf: this.dateToFilterHigher
          },
          silent: true,
          onSuccess: (response) => {
            this.viagens = response.data;
            console.log(this.viagens);
            this.setNovaPlacaEMotorista()
            this.filterDate();
            this.loading = false;
            this.populaCercas();
          },
          onError: (e) => {
            console.log(e);
            this.loading = false;
            this.sysError = e;
            this.authDialog = true;
          },
        });
          setTimeout(() => this.initialize(), 30000);
      },
      showHelpDialog() {
        this.helpDialog = true;
      },
      closeHelpDialog() {
        this.helpDialog = false;
      },
      placaRules(placa) {
        if (placa == null) {
          return "Placa é obrigatório";
        } else {
          if (placa.length === 0) {
            return "Placa é obrigatório";
          } else {
            if (!/[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/.test(placa)) {
              return "Placa inválida. Deve ser XXX9999 ou XXX9X99. Letras em maiúsculas";
            } else {
              return true;
            }
          }
        }
      },
      horarioRules() {
        if (this.horaProgramada == null) {
          return "Horário de início é obrigatório";
        } else {
          if (this.horaProgramada.length === 0) {
            return "Horário de início é obrigatório";
          } else {
            if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(this.horaProgramada)) {
              return "Horário inválido, deve estar entre 00:00 e 23:59";
            } else {
              return true;
            }
          }
        }
      },
      close() {
        this.dialog = false;
        this.editDialog = false;
        this.novaViagemDialog = false;
        this.registroDialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.deletedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      },
      registra() {
        this.$refs.form.validate();
        if (this.formValidado) {
          if (this.editedIndex == -1) {
            this.operacao = 0;
            this.novaViagemDialog = false;
            this.editedItem.status = -1
            this.editedItem.usuario_registro = this.user.id_usuario;
            this.editedItem.inicio = this.editedItem.inicio || this.formatDate(this.dataProgramada);
            this.editedItem.hora_programada = this.formatHoraProgramada(this.dataProgramada, this.horaProgramada);
            apiController.request(apiController.endpoints.insertCercafromaddress, {
              data: this.editedItem,
              silent: true,
              onSuccess: (response) => {
                this.mensagemAlerta = response.data.mensagem;
                this.tipoAlerta = "success";
                this.showAlert = true;
                this.editedItem.cerca_partida = response.data.cercas.partida;
                this.editedItem.cerca_chegada = response.data.cercas.chegada;
                this.finalizaRegistro();
              },
              onError: (e) => {
                console.log(e);
                if(e.response.status == 400) {
                  this.canConfirm = true;
                }
                this.sysError = e;
                this.authDialog = true;
              },
            });
            } else {
              this.operacao = 1;
              this.dialog = false;
              apiController.request(apiController.endpoints.monitriipUpdateViagem, {
                data: this.editedItem,
                silent: true,
                onSuccess: (response) => {
                  this.mensagemAlerta = response.data.mensagem;
                  this.tipoAlerta = "success";
                  this.showAlert = true;
                  this.close();
                  this.initialize();
                },
                onError: (e) => {
                  console.log(e);
                  this.sysError = e;
                  this.authDialog = true;
                },
              });
            }
        }
      },
      finalizaRegistro() {
        this.authDialog = false;
        this.showAlert = false;
        this.canConfirm = false;
        apiController.request(apiController.endpoints.monitriipRegistrarViagem, {
          data: this.editedItem,
          silent: true,
          onSuccess: (response) => {
            this.mensagemAlerta = response.data.mensagem;
            this.tipoAlerta = "success";
            this.showAlert = true;
            this.close();
            this.initialize();
          },
          onError: (e) => {
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      getNovoStatusViagem(item) {
        this.editedIndex = this.viagens.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (item.status === -1) {
          this.mensagemIniciar = `Deseja iniciar manualmente a viagem ${this.editedItem.autorizacao}?`;
        } else if (this.novoStatus === 0 || this.novoStatus === 2) {
          this.mensagemIniciar = `Deseja finalizar manualmente a viagem ${this.editedItem.autorizacao}?`;
        }
        this.registroDialog = true;
      },
      alteraRegistro() {
        if (this.editedItem.status !== -1) {
          this.$refs.form.validate();
        } else {
          this.novoStatus = 1;
          this.formValidado = true;
        }

        if (this.formValidado) {
          this.registroDialog = false;
          this.editedItem.status = this.novoStatus;
          this.editedItem.veiculo = this.veiculoItem;
          apiController.request(apiController.endpoints.monitriipInsertMovimento, {
            data: this.editedItem,
            silent: true,
            onSuccess: (response) => {
              this.updateTable(response);
            },
            onError: (e) => {
              console.log(e);
              this.sysError = e;
              this.authDialog = true;
            },
          });
        }
      },
      updateTable(response) {
        this.mensagemAlerta = response.data.mensagem
        if (response.data.erro) {
          this.tipoAlerta = "error";
          this.showAlert = true;
        } else {
          this.tipoAlerta = "success";
          this.showAlert = true;
        }
        this.close();
        this.initialize();
      },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          silent: true,
          onSuccess: (response) => {
            this.empresas = response.data;
          },
          onError: (e) => {
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      populaErrosViagem() {
        this.loadingErrosViagem = true;
        apiController.request(apiController.endpoints.monitriipGetLogserrosviagem, {
          params: { autorizacao: this.editedItem.autorizacao },
          silent: true,
          onSuccess: (response) => {
            this.errosViagem = response.data;
            this.loadingErrosViagem = false;
          },
          onError: (e) => {
            this.loadingErrosViagem = false;
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      populaMovimentosViagem() {
        this.loadingMovimentosViagem = true;
        apiController.request(apiController.endpoints.monitriipGetMovimentosviagem, {
          params: { autorizacao: this.editedItem.autorizacao },
          silent: true,
          onSuccess: (response) => {
            this.movimentosViagem = response.data;
            this.loadingMovimentosViagem = false;
          },
          onError: (e) => {
            this.loadingMovimentosViagem = false;
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      populaCercas() {
        apiController.request(apiController.endpoints.getallCercas, {
          silent: true,
          onSuccess: (response) => {
            this.cercas = response.data;
          },
          onError: (e) => {
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      populaMapa() {
        if (this.showMapa) {
          this.showMapa = false;
        } else {
          let inicio = this.movimentosViagem.filter((m) => m.registro == 1);
          let fim = this.movimentosViagem.filter((m) => m.registro == 0);
  
          this.dtiMapa = inicio.length > 0 ? DateUtils.getDateSQLFormatted(new Date(inicio[0].data_hora_evento)) : null;
          this.dtfMapa = fim.length > 0 ? DateUtils.getDateSQLFormatted(new Date(fim[fim.length - 1].data_hora_evento)) : DateUtils.getDateSQLFormatted(new Date());
          this.idVeiculosViagem = inicio[0] ? [inicio[0].id_veiculo] : [];
          this.key = this.key === 1 ? 0 : 1;
          this.showMapa = true;
        }
      },
      populaFuncionarios() {
        apiController.request(apiController.endpoints.getallFuncionarios, {
          silent: true,
          onSuccess: (response) => {
            this.motoristas = response.data;
          },
          onError: (e) => {
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      populaVeiculos() {
        apiController.request(apiController.endpoints.getallVeiculosativos, {
          silent: true,
          onSuccess: (response) => {
            this.veiculos = response.data;
            this.veiculosFiltered = this.veiculos; //.filter((v) => v.id_equipamento !== null);
          },
          onError: (e) => {
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      // populaEquipamentos() {
      //   axios
      //     .get(ApiBaseUrl + "/api/v1.0/getallequipamentosveiculos", {
      //       headers: { "x-access-token": this.token }
      //     })
      //     .then((response) => {
      //       this.equipamentos = response.data;
      //       this.veiculosFiltered = this.veiculos.filter((v) => this.equipamentos.findIndex((e) => v.id_equipamento === e.id_equipamento) !== -1);
      //       console.log(this.veiculosFiltered);
      //     })
      //     .catch((e) => {
      //       console.log(e);
      //       this.sysError = e;
      //       this.authDialog = true;
      //     })
      // },
      getRastreamentoVeiculo() {
        apiController.request(apiController.endpoints.monitriipGetVelocidadetempolocalizacao, {
          params: { placa: this.getPlaca(this.editedItem) },
          silent: true,
          onSuccess: (response) => {
            this.veiculoItem = response.data[0];
            this.alteraRegistro();
          },
          onError: (e) => {
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      editItem(item) {
        if (item.motorista) {
          this.editedIndex = this.viagens.indexOf(item);
        } else {
          this.editedIndex = -1
        }

        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        this.deletedItem = Object.assign({}, item);
        this.mensagemdialog =
          "Confirma a exclusão da viagem " + item.autorizacao + " no sentido " + this.getSentido(item) + " ?";
        this.showConfirmButton = true;
        this.messageDismissButton = "Não";
        this.messageConfirmButton = "Sim";
        this.confirmDialog = true;
      },
      deleteFromDatabase() {
        this.operacao = 2;
        this.confirmDialog = false;
        apiController.request(apiController.endpoints.monitriipDeleteViagem, {
          data: this.deletedItem,
          silent: true,
          onSuccess: (response) => {
            this.updateTable(response);
          },
          onError: (e) => {
            alert("ERRO");
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
      getViagemStyle(item) {
        if (!item.placa_registrada) {
          return null;
        } else if (item.problema_cerca) {
          return 'viagemStyleWrong';
        } else {
          if (item.placa_registrada == item.placa) {
            return 'viagemStyleOk';
          } else {
            return 'viagemStyleInconsistent';
          }
        }
      },
      getPlaca(item) {
        return item.placa_registrada !== null ? item.placa_registrada : item.placa
      },
      getOrdem(item) {
        return item.ordem_registrada !== null ? item.ordem_registrada : item.ordem
      },
      getImei(item) {
        return item.imei_registrado !== null ? item.imei_registrado : item.imei
      },
      getStatusExtenso(item) {
        return item.status !== null ? item.status_extenso : 'Não registrada'
      },
      getSentido(item) {
        if (item.sentido_registrado !== null) {
          let sentido = this.sentidos[item.sentido_registrado + 1] || this.sentidos[item.sentido_registrado - 1]
          return sentido.texto
        }
        return this.sentidos[item.sentido - 1] ? this.sentidos[item.sentido - 1].texto : null
      },
      filterDate() {
        this.$refs.dateMenuFilterLower.save(this.dateToFilterLower);
        this.$refs.dateMenuFilterHigher.save(this.dateToFilterHigher);        
        this.dateMenuFilterLower = false;
        this.dateMenuFilterHigher = false;
        this.viagensFiltered = this.viagens.filter((viagem) => {
          let dateParts = viagem.inicio.split("/");
          let viagemDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
          let lowerLimitDate = new Date(this.dateToFilterLower);
          let higherLimitDate = new Date(this.dateToFilterHigher);
          higherLimitDate.setDate(higherLimitDate.getDate() + 1);
          return lowerLimitDate <= viagemDate && viagemDate < higherLimitDate;
        });
      },
      filterMotorista(item, queryText) {
        const nomeMotorista = item.nome.toLowerCase();
        const busca = queryText.toLowerCase();
        return nomeMotorista.indexOf(busca) > -1;
      },
      filterVeiculo(item, queryText) {
        const placa = item.placa.toLowerCase();
        const busca = queryText.toLowerCase();
        return placa.indexOf(busca) > -1;
      },
      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      formatHoraProgramada(date, time) {
        if (!date || !time) return null;

        return `${this.formatDate(date)} ${time}`
      },
      initializeDateFilterLower(daySpan) {
        if (!this.dateToFilterLower) {
          let dateToCalculateFrom = new Date();
          dateToCalculateFrom.setDate(dateToCalculateFrom.getDate() + daySpan);
          this.dateToFilterLower = dateToCalculateFrom.toISOString().slice(0,10);
        }
      },
      initializeDateFilterHigher(daySpan) {
        if (!this.dateToFilterHigher) {
          let dateToCalculateFrom = new Date();
          dateToCalculateFrom.setDate(dateToCalculateFrom.getDate() + daySpan);
          this.dateToFilterHigher = dateToCalculateFrom.toISOString().slice(0,10);
        }
      },
      setNovaPlacaEMotorista() {
        this.viagens.forEach((viagem) => {
          viagem.novoMotorista = viagem.motorista;
          viagem.novaPlaca = viagem.placa_registrada;
        });
      },
      showInfo(item) {
        if (item.motorista) {
          this.editedItem = Object.assign({}, item);
          this.populaLogsViagem();
          this.populaErrosViagem();
          this.populaMovimentosViagem();
          this.infoDialog = true;
        } else {
          this.editItem(item);
        }
      },
      closeInfoDialog() {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.errosViagem = [];
        this.movimentosViagem = [];
        this.showMapa = false;
        this.dtiMapa = null;
        this.dtfMapa = null;
        this.idVeiculosViagem = [];
        this.infoDialog = false;
      },
      populaLogsViagem() {
        this.loadingLogsViagem = true;
        apiController.request(apiController.endpoints.monitriipGetLogsviagem, {
          params: { autorizacao: this.editedItem.autorizacao },
          silent: true,
          onSuccess: (response) => {
            this.logsViagem = response.data;
            this.viagemDownload = this.editedItem.autorizacao;
            this.loadingLogsViagem = false;
          },
          onError: (e) => {
            this.loadingLogsViagem = false;
            console.log(e);
            this.sysError = e;
            this.authDialog = true;
          },
        });
      },
    },
  };
  </script>